import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const AutoPromoModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // 1. Pehli baar website khulne ke 5 second baad dikhao
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);

    // 2. Har 90 seconds (1.5 min) mein pop-up ko repeat karo
    const repeatInterval = setInterval(() => {
      setIsVisible(true);
    }, 170000); 

    return () => {
      clearTimeout(initialTimer);
      clearInterval(repeatInterval);
    };
  }, []);

  const closePromo = () => {
    setIsVisible(false);
  };

  const openDonate = () => {
    setIsVisible(false);
    // Donate click hone par is session ke liye interval clear kar sakte hain 
    // taaki user disturb na ho, ya fir aane dein.
    window.dispatchEvent(new Event('openDonationModal'));
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm font-poppins">
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 40 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 40 }}
            className="bg-white rounded-[2rem] shadow-2xl max-w-md w-full overflow-hidden relative border border-slate-100"
          >
            {/* Close Button */}
            <button onClick={closePromo} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 z-10 p-1 bg-slate-100 rounded-full transition-colors">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Impact Image */}
            <div className="h-48 relative">
              <img 
                src="https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?q=80&w=2070" 
                className="w-full h-full object-cover" 
                alt="Sevaa Impact"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent"></div>
            </div>

            {/* Content Section */}
            <div className="p-8 text-center pt-2">
              <h3 className="text-2xl font-bold text-slate-900 leading-tight mb-4 tracking-tight">
                Bring dignity and care to <br />
                <span className="text-[#0f766e]">our community.</span> 🧡
              </h3>
              
              <p className="text-slate-500 font-medium text-sm leading-relaxed mb-8">
                Every contribution matters. Join Sevaa Foundation and get <span className="font-bold text-orange-600">80G Tax Benefits</span> on your donation.
              </p>

              {/* Action Button */}
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={openDonate}
                className="w-full bg-[#ffb000] hover:bg-[#0f766e] hover:text-white text-gray-900 font-black py-4 rounded-2xl shadow-xl transition-all uppercase tracking-widest text-[11px]"
              >
                Donate Now ❤️
              </motion.button>
              
              <p className="mt-4 text-[9px] text-slate-400 font-bold uppercase tracking-[0.2em]">
                Verified Sevaa Foundation Initiative
              </p>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default AutoPromoModal;